import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.page.DOC}
  query MosaicPagesForDev($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          pages {
            ...FragmentMosaicPageForDev
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.MosaicPagesForDevQuery,
    ents.core.mosaic.Page[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicDev',
        graphql.transformers.OUT.select(
          'pages',
          graphql.transformers.OUT.list(fragments.page.TRANSFORMER, {
            onNullish: 'remove',
          }),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.MosaicPagesForDevQuery,
  ents.core.mosaic.Page[],
  graphql.schema.MosaicPagesForDevQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
